/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContentManagerUserGroupDashboardContentResponseLearningEventPermissions } from './ContentManagerUserGroupDashboardContentResponseLearningEventPermissions';
import {
    ContentManagerUserGroupDashboardContentResponseLearningEventPermissionsFromJSON,
    ContentManagerUserGroupDashboardContentResponseLearningEventPermissionsFromJSONTyped,
    ContentManagerUserGroupDashboardContentResponseLearningEventPermissionsToJSON,
} from './ContentManagerUserGroupDashboardContentResponseLearningEventPermissions';
import type { ContentParticipationReassignResponseUserGroupsInnerLearningEventNearestDay } from './ContentParticipationReassignResponseUserGroupsInnerLearningEventNearestDay';
import {
    ContentParticipationReassignResponseUserGroupsInnerLearningEventNearestDayFromJSON,
    ContentParticipationReassignResponseUserGroupsInnerLearningEventNearestDayFromJSONTyped,
    ContentParticipationReassignResponseUserGroupsInnerLearningEventNearestDayToJSON,
} from './ContentParticipationReassignResponseUserGroupsInnerLearningEventNearestDay';

/**
 * Content learning event
 * @export
 * @interface ContentParticipationIndexResponseUserGroupsInnerLearningEvent
 */
export interface ContentParticipationIndexResponseUserGroupsInnerLearningEvent {
    /**
     * 
     * @type {number}
     * @memberof ContentParticipationIndexResponseUserGroupsInnerLearningEvent
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ContentParticipationIndexResponseUserGroupsInnerLearningEvent
     */
    form: ContentParticipationIndexResponseUserGroupsInnerLearningEventFormEnum;
    /**
     * 
     * @type {string}
     * @memberof ContentParticipationIndexResponseUserGroupsInnerLearningEvent
     */
    location: string;
    /**
     * 
     * @type {number}
     * @memberof ContentParticipationIndexResponseUserGroupsInnerLearningEvent
     */
    minimum_capacity: number;
    /**
     * 
     * @type {number}
     * @memberof ContentParticipationIndexResponseUserGroupsInnerLearningEvent
     */
    maximum_capacity: number;
    /**
     * 
     * @type {boolean}
     * @memberof ContentParticipationIndexResponseUserGroupsInnerLearningEvent
     */
    unlimited_capacity: boolean;
    /**
     * 
     * @type {string}
     * @memberof ContentParticipationIndexResponseUserGroupsInnerLearningEvent
     */
    external_id: string;
    /**
     * 
     * @type {ContentManagerUserGroupDashboardContentResponseLearningEventPermissions}
     * @memberof ContentParticipationIndexResponseUserGroupsInnerLearningEvent
     */
    permissions: ContentManagerUserGroupDashboardContentResponseLearningEventPermissions;
    /**
     * 
     * @type {Date}
     * @memberof ContentParticipationIndexResponseUserGroupsInnerLearningEvent
     */
    start_date: Date;
    /**
     * 
     * @type {Date}
     * @memberof ContentParticipationIndexResponseUserGroupsInnerLearningEvent
     */
    end_date: Date;
    /**
     * 
     * @type {number}
     * @memberof ContentParticipationIndexResponseUserGroupsInnerLearningEvent
     */
    days_count: number;
    /**
     * 
     * @type {number}
     * @memberof ContentParticipationIndexResponseUserGroupsInnerLearningEvent
     */
    total_hours: number;
    /**
     * 
     * @type {ContentParticipationReassignResponseUserGroupsInnerLearningEventNearestDay}
     * @memberof ContentParticipationIndexResponseUserGroupsInnerLearningEvent
     */
    nearest_day?: ContentParticipationReassignResponseUserGroupsInnerLearningEventNearestDay;
}


/**
 * @export
 */
export const ContentParticipationIndexResponseUserGroupsInnerLearningEventFormEnum = {
    Online: 'online',
    Combined: 'combined',
    InPerson: 'in_person',
    InPersonAndOnline: 'in_person_and_online'
} as const;
export type ContentParticipationIndexResponseUserGroupsInnerLearningEventFormEnum = typeof ContentParticipationIndexResponseUserGroupsInnerLearningEventFormEnum[keyof typeof ContentParticipationIndexResponseUserGroupsInnerLearningEventFormEnum];


/**
 * Check if a given object implements the ContentParticipationIndexResponseUserGroupsInnerLearningEvent interface.
 */
export function instanceOfContentParticipationIndexResponseUserGroupsInnerLearningEvent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "form" in value;
    isInstance = isInstance && "location" in value;
    isInstance = isInstance && "minimum_capacity" in value;
    isInstance = isInstance && "maximum_capacity" in value;
    isInstance = isInstance && "unlimited_capacity" in value;
    isInstance = isInstance && "external_id" in value;
    isInstance = isInstance && "permissions" in value;
    isInstance = isInstance && "start_date" in value;
    isInstance = isInstance && "end_date" in value;
    isInstance = isInstance && "days_count" in value;
    isInstance = isInstance && "total_hours" in value;

    return isInstance;
}

export function ContentParticipationIndexResponseUserGroupsInnerLearningEventFromJSON(json: any): ContentParticipationIndexResponseUserGroupsInnerLearningEvent {
    return ContentParticipationIndexResponseUserGroupsInnerLearningEventFromJSONTyped(json, false);
}

export function ContentParticipationIndexResponseUserGroupsInnerLearningEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContentParticipationIndexResponseUserGroupsInnerLearningEvent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'form': json['form'],
        'location': json['location'],
        'minimum_capacity': json['minimum_capacity'],
        'maximum_capacity': json['maximum_capacity'],
        'unlimited_capacity': json['unlimited_capacity'],
        'external_id': json['external_id'],
        'permissions': ContentManagerUserGroupDashboardContentResponseLearningEventPermissionsFromJSON(json['permissions']),
        'start_date': (new Date(json['start_date'])),
        'end_date': (new Date(json['end_date'])),
        'days_count': json['days_count'],
        'total_hours': json['total_hours'],
        'nearest_day': !exists(json, 'nearest_day') ? undefined : ContentParticipationReassignResponseUserGroupsInnerLearningEventNearestDayFromJSON(json['nearest_day']),
    };
}

export function ContentParticipationIndexResponseUserGroupsInnerLearningEventToJSON(value?: ContentParticipationIndexResponseUserGroupsInnerLearningEvent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'form': value.form,
        'location': value.location,
        'minimum_capacity': value.minimum_capacity,
        'maximum_capacity': value.maximum_capacity,
        'unlimited_capacity': value.unlimited_capacity,
        'external_id': value.external_id,
        'permissions': ContentManagerUserGroupDashboardContentResponseLearningEventPermissionsToJSON(value.permissions),
        'start_date': (value.start_date.toISOString().substr(0,10)),
        'end_date': (value.end_date.toISOString().substr(0,10)),
        'days_count': value.days_count,
        'total_hours': value.total_hours,
        'nearest_day': ContentParticipationReassignResponseUserGroupsInnerLearningEventNearestDayToJSON(value.nearest_day),
    };
}

